import { axios } from 'lib/axios';
import { getToken, messaging } from 'lib/firebase';

export const getLoggedInUser = async () => {
  let fcmToken = null;

  // Step 1: Check if notifications are already allowed
  if (Notification.permission === 'granted') {
    try {
      // Step 2: Attempt to get FCM token
      fcmToken = await getToken(messaging, {
        vapidKey:
          'BHg8G7gzUpRJzqkKngahHybH3OdUQmOlxYA3q2DytjrLyFyzAh_WUG1Y38rbRyPR5frUCeaK0vnqsoSH2rNc9y8',
      });
    } catch (error) {
      console.error('FCM token retrieval failed:', error);
    }
  } else if (Notification.permission === 'default') {
    // Step 3: User has not responded yet, we skip the request and show prompt via UI (e.g. NotificationsConsent component)
    console.warn(
      'Notification permission not yet granted. Prompt user with NotificationsConsent.'
    );
  }

  // Step 4: Make request with or without token (token could be null)
  return axios.get(`/user/me/${fcmToken}`);
};
